import Mock from 'Mock';
import breadcrumbData from '@/assets/js/breadcrumb.js';
const debounce = (fn, Intervals, ...args) => {
  let timeNo;
  return (...params) => {
    clearTimeout(timeNo);
    timeNo = setTimeout(() => {
      fn(...args, ...params);
      clearTimeout(timeNo);
    }, Intervals);
  };
};
const setHeaderTitle = debounce(title => {
  document.title = title;
}, 20);

export default {
  install(Vue) {
    Vue.mixin({
      data() {
        return {
          Mock,
        };
      },
      watch: {
        $route({ meta: { title } }) {
          setHeaderTitle(title);
        },
      },
    });
  },
};

// 计算面包屑的混入
export const breadcrumb = {
  computed: {
    breadcrumb() {
      return breadcrumbData.get(this.$route.name);
    },
  },
};
